import {
  GroupedAgeGroupToYearsResults,
  PrevProjDataResponse,
} from "@/dashboard-api-types/api/epidemiologyData.types";

type colors = "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark";

interface options {
  labels?: string[];
  yAxisID?: string[];
}

export const formatGroupedDataToChart = (
  groupedData: GroupedAgeGroupToYearsResults,
  options?: options
) => {
  const { labels, yAxisID } = options || {};
  const ageGroups = Object.keys(groupedData ?? {});
  const colors: colors[] = ["info", "error", "warning", "secondary"];
  return {
    labels: Object.keys(groupedData?.[ageGroups[0]] ?? {}),
    datasets: ageGroups.map((ageGroup, index) => {
      return {
        label: labels ? labels[index] : ageGroup,
        color: colors[index % colors.length],
        data: Object.values(groupedData?.[ageGroup] ?? {}).map((e: any) => e?.value) || [],
        yAxisID: yAxisID ? yAxisID[index % yAxisID.length] : undefined,
      };
    }),
  };
};

export const formatPrevProjDataToChart = (
  prevProjData: PrevProjDataResponse["prevProjData"],
  options?: options
) => {
  const { labels, yAxisID } = options || {};
  const colors: colors[] = ["error", "warning", "success", "light"];
  return {
    labels: Object.keys(prevProjData?.incidence ?? {}),
    datasets: Object.keys(prevProjData ?? {}).map((changeName, index) => {
      const dataForKey = prevProjData[changeName as keyof PrevProjDataResponse["prevProjData"]];
      return {
        label: labels ? labels[index] : changeName,
        color: colors[index % colors.length],
        data: Object.values(dataForKey ?? {}).map((e: any) => e?.absolute) || [],
        yAxisID: yAxisID ? yAxisID[index % yAxisID.length] : undefined,
      };
    }),
  };
};
